module.exports = __webpack_public_path__ + "static/img/downapp_2.5f47455.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/index/img/downapp_2.png
// module id = jAYY
// module chunks = 1